import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import api from "../../services/api";
import { HeyatYoluContext } from "../../App";
import { toast } from "react-toastify";
import { FaSave, FaArrowLeft, FaCalendar, FaMapMarkerAlt, FaTrash, FaPlus } from "react-icons/fa";

function EditMemorialProfileDashboard() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { religions, relationTypes } = useContext(HeyatYoluContext);
  
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  
  const [ceremonies, setCeremonies] = useState({
    threeDay: { active: false, date: null, location: "", mapLink: "" },
    sevenDay: { active: false, date: null, location: "", mapLink: "" },
    fortyDay: { active: false, date: null, location: "", mapLink: "" },
    anniversary: { active: false, date: null, location: "", mapLink: "" },
  });

  const [formData, setFormData] = useState({
    firstName: "",
    fatherName: "",
    lastName: "",
    dateOfBirth: null,
    dateOfDeath: null,
    religionId: "",
    birthPlace: "",
    deathPlace: "",
    biography: "",
  });

  const [photo, setPhoto] = useState(null);
  const [existingPhotoUrl, setExistingPhotoUrl] = useState("");
  const [mediaFiles, setMediaFiles] = useState([]);
  const [existingMedia, setExistingMedia] = useState([]);
  const [deletedMediaIds, setDeletedMediaIds] = useState([]);
  const [isMartyr, setIsMartyr] = useState(false);
  const [martyrDocument, setMartyrDocument] = useState(null);
  const [existingMartyrDocumentUrl, setExistingMartyrDocumentUrl] = useState("");
  const [mourners, setMourners] = useState([]);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await api.get(`/admin/profiles/${id}`);
        const p = res.data;
        
        setFormData({
          firstName: p.firstName,
          fatherName: p.fatherName,
          lastName: p.lastName,
          dateOfBirth: new Date(p.dateOfBirth),
          dateOfDeath: new Date(p.dateOfDeath),
          religionId: p.religionId,
          birthPlace: p.birthPlace,
          deathPlace: p.deathPlace,
          biography: p.biography,
        });
        
        setExistingPhotoUrl(p.photoUrl);
        setExistingMedia(p.media || []);
        setIsMartyr(p.isMartyr);
        setExistingMartyrDocumentUrl(p.martyrDocumentUrl);
        setMourners(p.mourners || []);

        setCeremonies({
          threeDay: p.threeDay
            ? {
              active: true,
              date: new Date(p.threeDay.date),
              location: p.threeDay.location || "",
              mapLink: p.threeDay.mapLink || "",
            }
            : { active: false, date: null, location: "", mapLink: "" },
          sevenDay: p.sevenDay
            ? {
              active: true,
              date: new Date(p.sevenDay.date),
              location: p.sevenDay.location || "",
              mapLink: p.sevenDay.mapLink || "",
            }
            : { active: false, date: null, location: "", mapLink: "" },
          fortyDay: p.fortyDay
            ? {
              active: true,
              date: new Date(p.fortyDay.date),
              location: p.fortyDay.location || "",
              mapLink: p.fortyDay.mapLink || "",
            }
            : { active: false, date: null, location: "", mapLink: "" },
          anniversary: p.anniversary
            ? {
              active: true,
              date: new Date(p.anniversary.date),
              location: p.anniversary.location || "",
              mapLink: p.anniversary.mapLink || "",
            }
            : { active: false, date: null, location: "", mapLink: "" },
        });
      } catch (err) {
        toast.error("Profil yüklənə bilmədi");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleExistingMediaRemove = (index) => {
    const removedItem = existingMedia[index];
    setDeletedMediaIds(prev => [...prev, removedItem.id]);
    setExistingMedia(prev => prev.filter((_, i) => i !== index));
  };

  const handleNewMediaRemove = (index) => {
    setMediaFiles(prev => prev.filter((_, i) => i !== index));
  };

  const handleMournerChange = (index, field, value) => {
    const updated = [...mourners];
    updated[index][field] = value;
    setMourners(updated);
  };

  const addMournerField = () => {
    setMourners([...mourners, { relationTypeId: "", fullName: "" }]);
  };

  const removeMournerField = (index) => {
    setMourners(prev => prev.filter((_, i) => i !== index));
  };

  // ✅ Helper funksiya: DateOnly formatı (YYYY-MM-DD)
  const formatDateOnly = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    
    const data = new FormData();

    data.append("FirstName", formData.firstName);
    data.append("FatherName", formData.fatherName);
    data.append("LastName", formData.lastName);
    data.append("DateOfBirth", formatDateOnly(formData.dateOfBirth)); // ✅ DÜZƏLDILDI
    data.append("DateOfDeath", formatDateOnly(formData.dateOfDeath)); // ✅ DÜZƏLDILDI
    data.append("BirthPlace", formData.birthPlace);
    data.append("DeathPlace", formData.deathPlace);
    data.append("Biography", formData.biography || "");
    data.append("ReligionId", formData.religionId);
    data.append("IsMartyr", isMartyr);

    if (photo) data.append("Photo", photo);
    if (isMartyr && martyrDocument) data.append("MartyrDocument", martyrDocument);

    mediaFiles.forEach(file => {
      data.append("MediaFiles", file);
    });

    if (deletedMediaIds.length > 0) {
      data.append("DeletedMediaIds", deletedMediaIds.join(","));
    }

    mourners.forEach((m, i) => {
      data.append(`Mourners[${i}].RelationTypeId`, m.relationTypeId);
      data.append(`Mourners[${i}].FullName`, m.fullName);
    });

    // ✅ Mərasimləri düzgün formatda göndəririk
    if (ceremonies.threeDay.active && ceremonies.threeDay.date) {
      data.append("ThreeDay.Date", formatDateOnly(ceremonies.threeDay.date)); // ✅ DÜZƏLDILDI
      data.append("ThreeDay.Location", ceremonies.threeDay.location || "");
      data.append("ThreeDay.MapLink", ceremonies.threeDay.mapLink || "");
    }
    
    if (ceremonies.sevenDay.active && ceremonies.sevenDay.date) {
      data.append("SevenDay.Date", formatDateOnly(ceremonies.sevenDay.date)); // ✅ DÜZƏLDILDI
      data.append("SevenDay.Location", ceremonies.sevenDay.location || "");
      data.append("SevenDay.MapLink", ceremonies.sevenDay.mapLink || "");
    }
    
    if (ceremonies.fortyDay.active && ceremonies.fortyDay.date) {
      data.append("FortyDay.Date", formatDateOnly(ceremonies.fortyDay.date)); // ✅ DÜZƏLDILDI
      data.append("FortyDay.Location", ceremonies.fortyDay.location || "");
      data.append("FortyDay.MapLink", ceremonies.fortyDay.mapLink || "");
    }
    
    if (ceremonies.anniversary.active && ceremonies.anniversary.date) {
      data.append("Anniversary.Date", formatDateOnly(ceremonies.anniversary.date)); // ✅ DÜZƏLDILDI
      data.append("Anniversary.Location", ceremonies.anniversary.location || "");
      data.append("Anniversary.MapLink", ceremonies.anniversary.mapLink || "");
    }

    try {
      await api.put(`/admin/updatememorialprofiles/${id}`, data);
      toast.success("Profil uğurla yeniləndi");
      navigate("/dashboard/memorial-profiles");
    } catch (err) {
      console.error("Redaktə xətası:", err.response?.data || err.message);
      toast.error(err.response?.data?.message || "Profil redaktə edilə bilmədi");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="hy-edit-profile-loading">
        <div className="hy-edit-profile-spinner" />
        <p>Yüklənir...</p>
      </div>
    );
  }

  const getCeremonyLabel = (key) => {
    const labels = {
      threeDay: "3-cü Gün",
      sevenDay: "7-ci Gün",
      fortyDay: "40-cı Gün",
      anniversary: "İl Dönümü"
    };
    return labels[key] || key;
  };

  return (
    <div className="hy-edit-profile-container">
      <div className="hy-edit-profile-header">
        <button onClick={() => navigate(-1)} className="hy-edit-profile-back-btn">
          <FaArrowLeft /> Geri
        </button>
        <h2 className="hy-edit-profile-title">Memorial Profil Redaktəsi</h2>
      </div>

      <form onSubmit={handleSubmit} className="hy-edit-profile-form">
        {/* Personal Info Section */}
        <div className="hy-edit-profile-section">
          <h3 className="hy-edit-profile-section-title">Şəxsi Məlumatlar</h3>
          <div className="hy-edit-profile-grid">
            <div className="hy-edit-profile-field">
              <label>Ad <span className="hy-edit-profile-required">*</span></label>
              <input name="firstName" value={formData.firstName} onChange={handleChange} required />
            </div>
            <div className="hy-edit-profile-field">
              <label>Ata adı <span className="hy-edit-profile-required">*</span></label>
              <input name="fatherName" value={formData.fatherName} onChange={handleChange} required />
            </div>
            <div className="hy-edit-profile-field">
              <label>Soyad <span className="hy-edit-profile-required">*</span></label>
              <input name="lastName" value={formData.lastName} onChange={handleChange} required />
            </div>
            <div className="hy-edit-profile-field">
              <label>Din <span className="hy-edit-profile-required">*</span></label>
              <select name="religionId" value={formData.religionId} onChange={handleChange} required>
                <option value="">-- Seçin --</option>
                {religions.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
              </select>
            </div>
          </div>
        </div>

        {/* Dates Section */}
        <div className="hy-edit-profile-section">
          <h3 className="hy-edit-profile-section-title">Tarixlər</h3>
          <div className="hy-edit-profile-grid">
            <div className="hy-edit-profile-field">
              <label><FaCalendar /> Doğum tarixi <span className="hy-edit-profile-required">*</span></label>
              <DatePicker
                selected={formData.dateOfBirth}
                onChange={(date) => setFormData(prev => ({ ...prev, dateOfBirth: date }))}
                dateFormat="dd/MM/yyyy"
                required
                className="hy-edit-profile-datepicker"
              />
            </div>
            <div className="hy-edit-profile-field">
              <label><FaCalendar /> Vəfat tarixi <span className="hy-edit-profile-required">*</span></label>
              <DatePicker
                selected={formData.dateOfDeath}
                onChange={(date) => setFormData(prev => ({ ...prev, dateOfDeath: date }))}
                dateFormat="dd/MM/yyyy"
                required
                className="hy-edit-profile-datepicker"
              />
            </div>
          </div>
        </div>

        {/* Places Section */}
        <div className="hy-edit-profile-section">
          <h3 className="hy-edit-profile-section-title">Məkanlar</h3>
          <div className="hy-edit-profile-grid">
            <div className="hy-edit-profile-field">
              <label><FaMapMarkerAlt /> Doğum yeri <span className="hy-edit-profile-required">*</span></label>
              <input name="birthPlace" value={formData.birthPlace} onChange={handleChange} required />
            </div>
            <div className="hy-edit-profile-field">
              <label><FaMapMarkerAlt /> Dəfn yeri <span className="hy-edit-profile-required">*</span></label>
              <input name="deathPlace" value={formData.deathPlace} onChange={handleChange} required />
            </div>
          </div>
        </div>

        {/* Biography */}
        <div className="hy-edit-profile-section">
          <h3 className="hy-edit-profile-section-title">Bioqrafiya</h3>
          <textarea
            name="biography"
            value={formData.biography}
            onChange={handleChange}
            rows={6}
            placeholder="Bioqrafiya məlumatlarını daxil edin..."
            className="hy-edit-profile-textarea"
          />
        </div>

        {/* Martyr Status */}
        {isMartyr && (
          <div className="hy-edit-profile-martyr-badge">
            ✅ Bu şəxs şəhid kimi qeyd edilib
          </div>
        )}

        {/* Photo Section */}
        <div className="hy-edit-profile-section">
          <h3 className="hy-edit-profile-section-title">Profil Şəkli</h3>
          {(photo || existingPhotoUrl) && (
            <div className="hy-edit-profile-photo-preview">
              <img
                src={photo ? URL.createObjectURL(photo) : `https://api.heyatyolu.az/${existingPhotoUrl}`}
                alt="Profil şəkli"
              />
            </div>
          )}
          <div className="hy-edit-profile-file-input">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setPhoto(e.target.files[0])}
              id="photo-upload"
            />
            <label htmlFor="photo-upload" className="hy-edit-profile-file-label">
              📷 Yeni şəkil seç
            </label>
          </div>
        </div>

        {/* Martyr Document */}
        {isMartyr && (
          <div className="hy-edit-profile-section">
            <h3 className="hy-edit-profile-section-title">Şəhidlik Sənədi</h3>
            {(martyrDocument || existingMartyrDocumentUrl) && (
              <div className="hy-edit-profile-photo-preview">
                <img
                  src={martyrDocument ? URL.createObjectURL(martyrDocument) : `https://api.heyatyolu.az/${existingMartyrDocumentUrl}`}
                  alt="Şəhid sənədi"
                />
              </div>
            )}
            <div className="hy-edit-profile-file-input">
              <input
                type="file"
                accept=".jpg,.jpeg,.png,.pdf"
                onChange={(e) => setMartyrDocument(e.target.files[0])}
                id="document-upload"
              />
              <label htmlFor="document-upload" className="hy-edit-profile-file-label">
                📄 Sənəd yüklə
              </label>
            </div>
          </div>
        )}

        {/* Mourners Section */}
        <div className="hy-edit-profile-section">
          <h3 className="hy-edit-profile-section-title">Yas Tutanlar</h3>
          {mourners.map((mourner, index) => (
            <div key={index} className="hy-edit-profile-mourner-row">
              <select
                value={mourner.relationTypeId}
                onChange={(e) => handleMournerChange(index, "relationTypeId", e.target.value)}
                required
              >
                <option value="">-- Əlaqə növü --</option>
                {relationTypes.map((type) => (
                  <option key={type.id} value={type.id}>{type.name}</option>
                ))}
              </select>
              <input
                type="text"
                placeholder="Ad və soyad"
                value={mourner.fullName}
                onChange={(e) => handleMournerChange(index, "fullName", e.target.value)}
                required
              />
              {mourners.length > 1 && (
                <button type="button" onClick={() => removeMournerField(index)} className="hy-edit-profile-btn-remove">
                  <FaTrash />
                </button>
              )}
            </div>
          ))}
          <button type="button" onClick={addMournerField} className="hy-edit-profile-btn-add">
            <FaPlus /> Yas tutanı əlavə et
          </button>
        </div>

        {/* Ceremonies Section */}
        <div className="hy-edit-profile-section">
          <h3 className="hy-edit-profile-section-title">🕯️ Mərasim Tarixləri</h3>
          {Object.entries(ceremonies).map(([key, value]) =>
            value.active && (
              <div key={key} className="hy-edit-profile-ceremony">
                <h4>{getCeremonyLabel(key)}</h4>
                <div className="hy-edit-profile-grid">
                  <div className="hy-edit-profile-field">
                    <label>Tarix</label>
                    <DatePicker
                      selected={value.date}
                      onChange={(date) => setCeremonies(prev => ({
                        ...prev,
                        [key]: { ...prev[key], date }
                      }))}
                      dateFormat="dd/MM/yyyy"
                      className="hy-edit-profile-datepicker"
                    />
                  </div>
                  <div className="hy-edit-profile-field">
                    <label>Məkan</label>
                    <input
                      type="text"
                      value={value.location}
                      onChange={(e) => setCeremonies(prev => ({
                        ...prev,
                        [key]: { ...prev[key], location: e.target.value }
                      }))}
                    />
                  </div>
                  <div className="hy-edit-profile-field hy-edit-profile-full-width">
                    <label>Xəritə linki</label>
                    <input
                      type="url"
                      value={value.mapLink}
                      onChange={(e) => setCeremonies(prev => ({
                        ...prev,
                        [key]: { ...prev[key], mapLink: e.target.value }
                      }))}
                      placeholder="https://maps.google.com/..."
                    />
                  </div>
                </div>
              </div>
            )
          )}
        </div>

        {/* Media Section */}
        {existingMedia.length > 0 && (
          <div className="hy-edit-profile-section">
            <h3 className="hy-edit-profile-section-title">Mövcud Media</h3>
            <div className="hy-edit-profile-media-grid">
              {existingMedia.map((item, i) => (
                <div key={i} className="hy-edit-profile-media-item">
                  {item.fileType === "image" ? (
                    <img src={`https://api.heyatyolu.az/${item.url}`} alt="media" />
                  ) : (
                    <video src={`https://api.heyatyolu.az/${item.url}`} controls />
                  )}
                  <button
                    type="button"
                    onClick={() => handleExistingMediaRemove(i)}
                    className="hy-edit-profile-media-remove"
                  >
                    <FaTrash />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="hy-edit-profile-section">
          <h3 className="hy-edit-profile-section-title">Yeni Media Faylları</h3>
          <div className="hy-edit-profile-file-input">
            <input
              type="file"
              multiple
              accept="image/*,video/*"
              onChange={(e) => setMediaFiles(prev => [...prev, ...Array.from(e.target.files)])}
              id="media-upload"
            />
            <label htmlFor="media-upload" className="hy-edit-profile-file-label">
              📁 Şəkil/Video əlavə et
            </label>
          </div>
          {mediaFiles.length > 0 && (
            <div className="hy-edit-profile-media-grid">
              {mediaFiles.map((file, index) => {
                const isImage = file.type.startsWith("image");
                const previewUrl = URL.createObjectURL(file);
                return (
                  <div key={index} className="hy-edit-profile-media-item">
                    {isImage ? <img src={previewUrl} alt="new" /> : <video src={previewUrl} controls />}
                    <button
                      type="button"
                      onClick={() => handleNewMediaRemove(index)}
                      className="hy-edit-profile-media-remove"
                    >
                      <FaTrash />
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="hy-edit-profile-actions">
          <button type="submit" disabled={saving} className="hy-edit-profile-btn-save">
            {saving ? (
              <>
                <div className="hy-edit-profile-btn-spinner" />
                Yadda saxlanılır...
              </>
            ) : (
              <>
                <FaSave />
                Dəyişiklikləri Yadda Saxla
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditMemorialProfileDashboard;
